import { initTenantSubdomainAndType } from "features/slices/tenantSlice";
import { useAppDispatch } from "hooks/useAppDispatch";
import React, { useState, useEffect } from "react";
import { Text } from "@ui-kitten/components";
import { View, Pressable } from "react-native";
import { BRANDING_URL } from "constants/";
import { AccountMemberDetails } from "features/types";
import FullScreenSpinner from "components/FullScreenSpinner";
import Button from "components/Button";
import LoginContainer from "components/LoginContainer";
import Chevron from "components/Chevron";
import { useFetchUserMembershipsQuery } from "queries/user.queries";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import { setStoredTenantSubdomain } from "utils/storageUtils";
import i18n from "plugins/localization";
import { toLogOut } from "utils/navigationUtils";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import { Image } from "expo-image";

const LOGO_SIZE = 25;

export default function SelectTenant() {
  const [enabled, setEnabled] = useState(false);
  const { data: memberships, isFetching: fetchingMemberships } =
    useFetchUserMembershipsQuery();
  const { data: branding, isFetching: fetchingBranding } =
    useFetchTenantBrandingQuery(enabled);
  const { refetch: refetchTenantConfig, isFetching: fetchingTenantConfig } =
    useFetchTenantConfigurationQuery();

  const dispatch = useAppDispatch();

  const handleMembershipClick = async (membership: AccountMemberDetails) => {
    await setStoredTenantSubdomain(membership.tenant.subdomain);
    setEnabled(true);
  };

  const loading =
    fetchingMemberships ||
    fetchingBranding ||
    fetchingTenantConfig ||
    !memberships;
  useEffect(() => {
    async function onBrandingChange() {
      if (!branding) return;
      await refetchTenantConfig();
      dispatch(initTenantSubdomainAndType(branding));
    }
    onBrandingChange();
  }, [branding]);

  if (loading) {
    return <FullScreenSpinner />;
  }

  return (
    <LoginContainer
      title={i18n.t("screens.SelectTenant.selectYourMembership")}
      showFanRallyLogo={false}
    >
      <View style={{ marginTop: 24 }}>
        {memberships.map((membership) => (
          <Pressable
            key={membership.id}
            onPress={() => handleMembershipClick(membership)}
            style={{
              padding: 12,
              backgroundColor: "white",
              borderRadius: 8,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 6,
            }}
          >
            <View style={{ width: LOGO_SIZE, height: LOGO_SIZE }}>
              <Image
                source={{
                  uri: `${BRANDING_URL}/logos/${membership.tenant.name}.svg`,
                }}
                style={{
                  width: LOGO_SIZE,
                  height: LOGO_SIZE,
                }}
              />
            </View>
            <Text category="h6">{membership.tenant.name}</Text>
            <Chevron />
          </Pressable>
        ))}

        <Button appearance="ghost" status="control" onPress={toLogOut}>
          {i18n.t("common.logOut")}
        </Button>
      </View>
    </LoginContainer>
  );
}
